const INSTALL_TIP_DISMISSED_KEY = 'bagtag_install_tip_dismissed';

/** True when the app is running as an installed home-screen / standalone PWA. */
export function isStandalonePwa(): boolean {
  if (typeof window === 'undefined') return false;
  const nav = window.navigator as Navigator & { standalone?: boolean };
  return nav.standalone === true
    || window.matchMedia('(display-mode: standalone)').matches
    || window.matchMedia('(display-mode: fullscreen)').matches;
}

export function isIosDevice(): boolean {
  if (typeof navigator === 'undefined') return false;
  return /iPad|iPhone|iPod/.test(navigator.userAgent)
    || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
}

export function shouldShowInstallTip(): boolean {
  if (typeof window === 'undefined' || isStandalonePwa()) return false;
  try {
    return localStorage.getItem(INSTALL_TIP_DISMISSED_KEY) !== '1';
  } catch {
    return true;
  }
}

export function dismissInstallTip(): void {
  try {
    localStorage.setItem(INSTALL_TIP_DISMISSED_KEY, '1');
  } catch {
    // ignore
  }
}
